import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { selectQuestions } from "../../../../redux/interactionsSlice";
import PanelCloseIcon from "../PanelCloseIcon.jsx";

const useStyles = makeStyles((theme) => ({
  container: {
    height: "100%",
    width: "40px",
    backgroundColor: theme.palette.grey.paper,
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    position: "relative"
  },
  collapseButton: {
    height: "44px",
    width: "44px",
    backgroundColor: "white",
    margin: "8px 0 16px 0px"
  },
  questionIndicators: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    padding: "8px 0",
    flex: 1
  },
  questionNumber: {
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    backgroundColor: "#e0e0e0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.text.secondary,
    fontWeight: "medium",
    fontSize: "12px",
    cursor: "pointer"
  },
  selectedQuestion: {
    backgroundColor: theme.palette.primary.main,
    color: "white"
  },
  assignmentText: {
    writingMode: "vertical-rl",
    textOrientation: "mixed",
    transform: "rotate(180deg)",
    color: theme.palette.text.secondary,
    fontSize: "14px",
    fontWeight: 500,
    letterSpacing: "0.1em",
    marginBottom: "16px",
    textAlign: "center",
    paddingTop: "16px"
  }
}));

const CollapsedLeftPanel = ({
  onToggleCollapse,
  submissionTaskId,
  handleQuestionSelect
}) => {
  const classes = useStyles();
  const questions = useSelector((state) =>
    selectQuestions(state, submissionTaskId)
  );
  const selectedQuestionId = useSelector(
    (state) => state.interactions.selectedInteractionId
  );

  // Combine both instructor and student questions for the collapsed view
  const allQuestions = [...questions];

  return (
    <Box className={classes.container}>
      <IconButton
        onClick={onToggleCollapse}
        className={classes.collapseButton}
        size="small">
        <PanelCloseIcon direction={"right"} />
      </IconButton>

      <Box className={classes.questionIndicators}>
        {allQuestions.map((question, index) => (
          <Box
            key={question.id}
            onClick={() => handleQuestionSelect(question)}
            className={`${classes.questionNumber} ${
              question.id === selectedQuestionId ? classes.selectedQuestion : ""
            }`}>
            {index + 1}
          </Box>
        ))}
      </Box>

      <Typography className={classes.assignmentText}>ASSIGNMENT</Typography>
    </Box>
  );
};

export default CollapsedLeftPanel;
